import { Action } from 'redux';

import { CollectionVisibility } from '~src/Collections/space/CollectionModels';

import { SetCollectionVisibility } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface SetCollectionVisibilityAction extends Action {
  contentIds: string[];
  visibility: CollectionVisibility;
}

export function setCollectionVisibility(contentIds: string[], visibility: CollectionVisibility): SetCollectionVisibilityAction {
  return {
    type: SetCollectionVisibility,
    contentIds,
    visibility
  };
}

export const isSetCollectionVisibility = isActionFactory<SetCollectionVisibilityAction>(SetCollectionVisibility);
